($ => {
  Drupal.behaviors.contactForms = {
    attach(context) {
      if (!$('.contact-form', context).length) {
        return false;
      }

      $('.contact-form .form-item').each((index, element) => {
        if (
          $(element).hasClass('js-form-type-textfield') ||
          $(element).hasClass('js-form-type-password') ||
          $(element).hasClass('js-form-type-email') ||
          $(element).hasClass('js-form-type-tel')
        ) {
          $(element)
            .find('input')
            .attr(
              'placeholder',
              $(element)
                .find('label')
                .text(),
            );
        }
        if ($(element).hasClass('js-form-type-textarea')) {
          $(element)
            .find('textarea')
            .attr(
              'placeholder',
              $(element)
                .find('label')
                .text(),
            );
        }
      });

      $('.contact-form select').selectric({
        disableOnMobile: false,
        onInit() {
          $(this)
            .closest('.selectric-wrapper')
            .find('.label')
            .html(
              $(this)
                .closest('.js-form-type-select')
                .find('label')
                .text(),
            );
        },
      });
    },
  };
})(jQuery);
